// extracted by mini-css-extract-plugin
export default {"container":"qqyzhx","title":"jyvfDm","subtitle":"JxYCJI","mobile-break":"EuEbiz","mobileBreak":"EuEbiz"};